import { createInsuranceProductPreset } from '../common/productPresetFactory'

const COPY_BY_PRESET = {
  default: {
    heroTitle: '운전자 범위와 차량 이용 패턴에 맞춰 자동차보험을 점검합니다',
    heroSubtitle: '대인·대물·자차·긴급출동 담보를 현재 운전 환경 기준으로 정리해 안내합니다.',
    formTitle: '자동차보험 상담 신청',
  },
  'clean-form': {
    heroTitle: '갱신 전 확인해야 할 자동차보험 기준을 정리합니다',
    heroSubtitle: '운전자 범위, 자차 필요성, 사고 시 보상 한도를 중심으로 상담합니다.',
    formTitle: '갱신 점검 상담',
  },
  'hanwha-sections': {
    heroTitle: '운전자 상황에 맞는 자동차보험 기준을 한 화면에서 안내합니다',
    heroSubtitle: '차량과 운행 패턴에 맞춰 담보별 확인 사항과 상담 절차를 정리합니다.',
    formTitle: '자동차보험 점검 신청',
  },
  'basic-template-4': {
    heroTitle: '갱신 전 꼭 봐야 할 자동차보험 핵심 포인트',
    heroSubtitle: '대인, 대물, 자차, 운전자 범위까지 꼭 필요한 항목을 먼저 짚어드립니다.',
    formTitle: '핵심 비교 요청',
  },
  'basic-template-5': {
    heroTitle: '사고 대비부터 자차 범위까지 전략적으로 점검하세요',
    heroSubtitle: '사고 대비, 자차 범위, 운전자 조건까지 현재 상황에 맞춰 차분하게 안내해드립니다.',
    formTitle: '1:1 자동차 상담',
  },
}

export function getProductAutoPreset(presetKey = 'default') {
  const copy =
    COPY_BY_PRESET[presetKey]
    || (presetKey === 'lead-gen-fullbleed' ? COPY_BY_PRESET['hanwha-sections'] : undefined)
    || COPY_BY_PRESET.default
  return createInsuranceProductPreset('PRODUCT_AUTO', copy, presetKey)
}
